import { useEffect, useLayoutEffect, useRef } from 'react';

export const useClickOutside = <T extends Element>(cb: (e: Event) => void) => {
  const effect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
  const ref = useRef<T>(null);
  const refCb = useRef(cb);

  effect(() => {
    refCb.current = cb;
  });

  useEffect(() => {
    const handler = (e: Event) => {
      const element = ref.current;
      if (
        element &&
        e.target &&
        e.target instanceof Node &&
        !element.contains(e.target)
      ) {
        refCb.current(e);
      }
    };

    document.addEventListener('mousedown', handler);
    document.addEventListener('touchstart', handler);

    return () => {
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('touchstart', handler);
    };
  }, []);

  return ref;
};
